import { TableCell, TableRow } from '@mui/material';
import EmptyState from 'components/EmptyState';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { TimetableList as TimetableListType } from 'types/timetable.types';

function TimetableListRows({ data }: { data: TimetableListType[] }) {
  const { t } = useTranslation('timetable');

  const haveData = data && data.length > 0;
  const isEmpty = !haveData;

  return (
    <>
      {haveData &&
        data.map((item) => (
          <TableRow
            key={item.id}
            sx={{
              textDecoration: 'none',
            }}
            hover
          >
            <TableCell sx={{ py: 1, overflow: 'hidden' }}>{t(`status_${item.status}`)}</TableCell>
            <TableCell sx={{ py: 1, overflow: 'hidden' }}>
              {item?.days?.map((day) => t(`weekday_${day}`)).join(', ')}
            </TableCell>
            <TableCell sx={{ py: 1, overflow: 'hidden' }}>
              {item.allPartitions ? t('all_partitions') : item.partitions?.join(', ') || ''}
            </TableCell>
            <TableCell sx={{ py: 1, overflow: 'hidden' }}>
              {item.initialHour && dayjs(item.initialHour, 'HH:mm:ss').format('HH:mm')}
            </TableCell>
            <TableCell sx={{ py: 1, overflow: 'hidden' }}>
              {typeof item.initialHourTolerance === 'number' && `${item.initialHourTolerance} min`}
            </TableCell>
            <TableCell sx={{ py: 1, overflow: 'hidden' }}>
              {item.endingHour && dayjs(item.endingHour, 'HH:mm:ss').format('HH:mm')}
            </TableCell>
            <TableCell sx={{ py: 1, overflow: 'hidden' }}>
              {typeof item.endingHourTolerance === 'number' && `${item.endingHourTolerance} min`}
            </TableCell>
          </TableRow>
        ))}
      {isEmpty && <TimetableListRowsEmpty />}
    </>
  );
}

function TimetableListRowsEmpty() {
  const { t } = useTranslation(['_common', 'timetable']);
  return (
    <EmptyState
      sx={{
        position: 'absolute',
        left: '0',
        right: '0',
        bottom: '0',
        top: '0',
      }}
      title={t('_common:there_is_still_nothing_here')}
      description=""
    />
  );
}

export default TimetableListRows;
